import { render } from "./MunicipiosFormView.vue?vue&type=template&id=82d2539a"
import script from "./MunicipiosFormView.vue?vue&type=script&lang=js"
export * from "./MunicipiosFormView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Workspace\\SalvandoArvores\\Codes\\salvando-arvores-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__